
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.width = this.getBreakpointValue(this.blok.width)
      styles.height = this.getBreakpointValue(this.blok.height)
      styles.top = this.getBreakpointValue(this.blok.top)
      styles.bottom = this.getBreakpointValue(this.blok.bottom)
      styles.left = this.getBreakpointValue(this.blok.left)
      styles.right = this.getBreakpointValue(this.blok.right)

      return styles
    },
    imgContainerStyles() {
      const styles = {}

      styles.backgroundImage = `url(${this.blok.src?.filename})`
      styles.backgroundSize =
        this.getBreakpointValue(this.blok.backgroundSize) || 'cover'
      styles.backgroundPosition =
        this.getBreakpointValue(this.blok.backgroundPosition) || 'bottom left'

      return styles
    },
  },
}
